import React from 'react';

const ColorChangingBox = ({
                              dateText = "დახარვეზებული დოკუმენტების ატვირთვის ბოლო ვადა:",
                              number = null,
                              title = "დარჩენილია",
                              hasNumber = true,
                              date = null,
                              startNumber,
                              isFinished = false,
                              hours,
                              minutes,
                              noDaysLeft = false,
                              isFinishedTitle
                          }) => {
    const green = { r: 46, g: 204, b: 113 };
    const yellow = { r: 241, g: 196, b: 15 };
    const red = { r: 231, g: 76, b: 60 };
    const gray = { r: 149, g: 165, b: 166 };

    const calculateBackgroundColor = () => {
        if (noDaysLeft) return `rgb(${red.r}, ${red.g}, ${red.b})`;
        if (isFinished) return `rgb(${gray.r}, ${gray.g}, ${gray.b})`;
        if (number < 0) return `rgb(${red.r}, ${red.g}, ${red.b})`;

        const totalRange = startNumber;
        const distance = startNumber - number;
        const ratio = distance / totalRange;

        let newColor;
        if (ratio <= 0.5) {
            const subRatio = ratio / 0.5;
            newColor = {
                r: Math.round(green.r * (1 - subRatio) + yellow.r * subRatio),
                g: Math.round(green.g * (1 - subRatio) + yellow.g * subRatio),
                b: Math.round(green.b * (1 - subRatio) + yellow.b * subRatio),
            };
        } else {
            const subRatio = (ratio - 0.5) / 0.5;
            newColor = {
                r: Math.round(yellow.r * (1 - subRatio) + red.r * subRatio),
                g: Math.round(yellow.g * (1 - subRatio) + red.g * subRatio),
                b: Math.round(yellow.b * (1 - subRatio) + red.b * subRatio),
            };
        }
        return `rgb(${newColor.r}, ${newColor.g}, ${newColor.b})`;
    };

    const backgroundColor = hasNumber && !isFinished
        ? calculateBackgroundColor()
        : `rgb(${gray.r}, ${gray.g}, ${gray.b})`;

    const finishedColor =
        isFinishedTitle === 'დასრულებულია - დადებითი პასუხი' || isFinishedTitle === 'დასრულებულია პირობით'
            ? '#2a9d8f'
            : isFinishedTitle === "ძალადაკარგულად გამოცხადდა" || isFinishedTitle === "გამოცხადდა ძალადაკარგულად" || isFinishedTitle === "განუხილველი" || isFinishedTitle
                ? '#e63946'
                : backgroundColor;

    return (
        <div
            style={{
                width: '450px',
                height: '65px',
                borderRadius: '18px',
                background: `linear-gradient(135deg, ${finishedColor}, ${finishedColor}cc)`,
                color: "#fff",
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                margin: '0 20px',
                boxShadow: '0 8px 20px rgba(0, 0, 0, 0.15)',
                fontSize: '16px',
                fontWeight: 600,
                letterSpacing: '0.5px',
                transition: 'all 0.4s ease',
                transform: 'translateY(0)',
                animation: 'fadeIn 0.4s ease forwards',
            }}
            className="color-changing-box"
        >
            {hasNumber && !isFinished ? (
                <p style={{ margin: 0, fontFamily: "FiraGO-SemiBold" }}>
                    {number < 0 ? "ვადაგადაცილებული" : `${title} ${number} დღე`}
                </p>
            ) : isFinished ? (
                <p style={{ margin: 0, fontFamily: "FiraGO-SemiBold" }}>
                    {isFinishedTitle}
                </p>
            ) : noDaysLeft ? (
                <p style={{ margin: 0, fontFamily: "FiraGO-SemiBold" }}>
                    დარჩენილია {hours} საათი და {minutes} წუთი
                </p>
            ) : (
                <p style={{ margin: 0, fontFamily: "FiraGO-SemiBold" }}>
                    {dateText} {date}
                </p>
            )}
        </div>
    );
};

export default ColorChangingBox;
